import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ViewMoreBtn from "../../components/ViewMoreBtn";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { arrowRight } from "../../../../assets/svg/Svg";
import { LuFilter } from "react-icons/lu";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getPayments } from "../../../../redux/slices/paymentSlice";
import { getUsersFeedbacks } from "../../../../redux/slices/feedbackSlice";

const UserFeedbacks = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [category, setCategory] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const { feedbacks, refetch } = useSelector((state) => state.feedbackSlice);

  const prevProps = useRef({ refetch }).current;

  useEffect(() => {
    if (prevProps.refetch != refetch) {
      dispatch(getUsersFeedbacks(setIsLoading));
    }
    return () => {
      prevProps.refetch = refetch;
    };
  }, [refetch]);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getUsersFeedbacks(setIsLoading));
  }, []);

  const columns = [
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Order ID",
      selector: (row) => row.orderId,
      sortable: true,
      center: true,
    },
    {
      name: "Actions",
      selector: (row) => row.action,
    },
  ];

  const data = feedbacks.map((feedback) => {
    return {
      id: 0,
      name: (
        <span
          style={{ color: "#be9528" }}
          onClick={() => navigate(`/user/${feedback?.createdBy}`)}
        >
          {feedback?.userDetails?.[0]?.fullName}
        </span>
      ),
      email : feedback?.userDetails?.[0]?.email,
      orderId: (
        <span
          style={{ color: "#be9528" }}
          onClick={() => navigate(`/bookings/program/${feedback?.orderDetails?.orderCode}`)}
        >
          {feedback?.orderDetails?.orderCode}
        </span>
      ),
      createdAt: new Date(feedback.createdAt)
        .toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        })
        .replace(/\//g, "-"),
      action: (
        <div className="d-flex">
          <ViewMoreBtn redirectUrl={`/user-feedback/${feedback._id}`} />
        </div>
      ),
    };
  });

  const filteredData = data.filter((item) => {
    const name =
      typeof item.name.props.children === "string"
        ? item.name.props.children.toLowerCase()
        : "";
    const email = item.email ? item.email.toLowerCase() : "";
    const orderCode =
      typeof item.orderId.props.children === "string"
        ? item.orderId.props.children.toLowerCase()
        : "";

    return (
      (name.includes(searchText.toLowerCase()) ||
        email.includes(searchText.toLowerCase()) ||
        orderCode.includes(searchText.toLowerCase())) &&
      (category ? item.status.props.children === category : true)
    );
  });

  const handleSearch = (value) => {
    setSearchText(value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const handleCategoryChange = (value) => {
    setCategory(value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const exportUsersToCsv = () => {
    const csvContent = convertToCsvString(filteredData);
    const encodedUri = encodeURI(csvContent);
    const blob = new Blob([csvContent], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "queries.csv";
    link.click();
  };

  const convertToCsvString = (data) => {
    const rows = [];
    const headers = Object.keys(data[0]);
    rows.push(headers.join(","));

    data.forEach((item) => {
      const values = headers.map((header) => item[header]);
      rows.push(values.join(","));
    });

    return rows.join("\n");
  };

  return (
    <>
      {isLoading ? (
        <div className="w-100 d-flex">
          <div class="spinner-border text-primary mx-auto" role="status"></div>
        </div>
      ) : (
        <>
          <div>
            <div className="page-header">
              <h3 className="page-title">User Feedbacks</h3>
            </div>
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body py-4">
                    <>
                      {/* <button onClick={handleClearRows}>Clear Selected Rows</button> */}
                      <DataTable
                        // title={<h6 className="card-title">Users List</h6>}
                        columns={columns}
                        data={filteredData}
                        pagination
                        paginationPerPage={20}
                        paginationRowsPerPageOptions={[
                          10, 20, 30, 50, 100, 200, 500,
                        ]}
                        // paginationComponent={customPagination}
                        highlightOnHover
                        pointerOnHover
                        subHeader
                        subHeaderAlign="left"
                        subHeaderComponent={
                          <>
                            <Row className="mb-3 w-100">
                              <Col
                                md={8}
                                className="d-flex align-items-start flex-column gap-2"
                              >
                                {/* <span className="d-flex align-items-center gap-2 me-3 filterby_label">
                                  <LuFilter />
                                  Filter By :
                                </span> */}
                                <div className="table_filter">
                                  <input
                                    type="text"
                                    className="form-control"
                                    style={{ width: '400px' }}
                                    placeholder="Search by name, email and orderCode"
                                    value={searchText}
                                    onChange={(e) =>
                                      handleSearch(e.target.value)
                                    }
                                  />
                                  {/* <select
                                    className="form-control h-54px w-auto"
                                    value={category}
                                    onChange={(e) =>
                                      handleCategoryChange(e.target.value)
                                    }
                                  >
                                    <option selected value="">
                                      Status
                                    </option>
                                    <option value="Success">Success</option>
                                    <option value="Failed">Failed</option>
                                  </select> */}
                                </div>
                              </Col>
                              <Col md={4} className="d-flex align-items-end">
                                <button
                                  className="btn_primary_outline_sm ms-auto"
                                  disabled={!filteredData.length}
                                  onClick={exportUsersToCsv}
                                >
                                  Export CSV
                                </button>
                              </Col>
                            </Row>
                          </>
                        }
                      />
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default UserFeedbacks;
